import { TableColumn } from '../../../components/DataTable/TableColumn';
import { TextColumn } from '../../../components/DataTable/TextColumn';
import { DateColumn } from '../../../components/DataTable/DateColumn';
import { Pagination } from '../../../interfaces/Pagination';
import { DataTable } from '../../../components/DataTable/DataTable';
import { BoynerOrder } from '../../../interfaces/Boyner/BoynerOrder';
import { BoynerProductsCell } from './BoynerProductsCell';
import { BoynerStatusCell } from './BoynerStatusCell';

const columns: TableColumn<BoynerOrder>[] = [
  {
    id: 'boyner-id',
    name: 'Boyner ID',
    accessor: (row) => <TextColumn value={row.boynerID.toString()} />,
  },
  {
    id: 'products',
    name: 'Ürünler',
    accessor: (row) => <BoynerProductsCell order={row} />,
  },
  {
    id: 'status',
    name: 'Durum',
    align: 'center',
    accessor: (row) => <BoynerStatusCell status={row.status} />,
  },
  {
    id: 'created-at',
    name: 'Sipariş Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
];

type BoynerOrdersTableProps = {
  orders: BoynerOrder[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const BoynerOrdersTable = (props: BoynerOrdersTableProps) => {
  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.orders}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
    />
  );
};
